"use client"

import { useAppDispatch } from "@/lib/redux/hooks"
import { flightActions } from "@/lib/redux/features/flight/reduce"
import { Input, InputProps } from "antd"
import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react"
import { SelectPlacementContext } from "."
import { useTETranslation } from "@/hooks/app/useTETranslation"

type InputSearchProps = InputProps & {
  onSearch?: (searchValue?: string) => void,
}

export type InputSearchRef = {
  setSearchValue: (value: any) => void,
  focus: () => void,
  contains: (target: Node) => boolean,
}

export const InputSearch = forwardRef<InputSearchRef, InputSearchProps>(({ onSearch: onCustomSearch, ...props }, ref) => {
  const [searchValue, setSearchValue] = useState<any>(props?.value || '')
  const refTimeoutSearch = useRef<any>(null)
  const refInput = useRef<any>(null)
  const dispatch = useAppDispatch()
  const { onSearch, size: cardSize, value: airport, open } = useContext(SelectPlacementContext)
  const { getAirportCityName } = useTETranslation()
  useEffect(() => {
    setSearchValue(props?.value)
  }, [props?.value])

  useImperativeHandle(ref, () => {
    return {
      setSearchValue: (value: any) => {
        setSearchValue(value)
      },
      focus: () => {
        refInput.current.focus()
        if (open) {
          open()
        }
      },
      contains: (target: Node) => Boolean(refInput.current?.nativeElement?.contains(target))
    }
  }, [refInput.current])

  return (
    <Input
      {...props}
      ref={refInput}
      value={searchValue}
      // prefix={cardSize === 'small'
      //   ? <Title level={4} style={{ margin: 0, fontSize: '2rem', lineHeight: 1 }}>{airport?.code || ""}</Title>
      //   : undefined
      // }
      onFocus={(e) => {
        open?.()
        const q = e.target.value || ""
        dispatch(flightActions.searchAirport({
          value: q,
          searchPopular: !q || q === getAirportCityName(airport, { shownCode: true })
        }))
      }}
      onChange={(e) => {
        open?.()
        if (refTimeoutSearch.current) {
          clearTimeout(refTimeoutSearch.current)
        }
        refTimeoutSearch.current = setTimeout(() => {
          const q = e.target.value || ""
          if (q.length >= 1) {
            dispatch(flightActions.searchAirport({
              value: q,
              searchPopular: q === getAirportCityName(airport, { shownCode: true })
            }))
          }

        }, 500)
        setSearchValue(e.target.value)
        if (onSearch) {
          onSearch(e.target.value)
        }
        if (onCustomSearch) {
          onCustomSearch(e.target.value)
        }
      }}
    />
  )
})

export default InputSearch